import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=5188c46d&scoped=true"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"
import style0 from "./AppNav.vue?vue&type=style&index=0&id=5188c46d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188c46d",
  null
  
)

export default component.exports